import React from "react";

const FeedbackIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.4984L14.125 15.1234C14.225 15.2068 14.325 15.2111 14.425 15.1364C14.525 15.0618 14.5583 14.9658 14.525 14.8484L13.7 12.1984L15.925 10.4484C16.0083 10.3651 16.0333 10.2691 16 10.1604C15.9667 10.0518 15.8917 9.99777 15.775 9.99844H13.1L12.25 7.32344C12.2167 7.20677 12.1333 7.14844 12 7.14844C11.8667 7.14844 11.7833 7.20677 11.75 7.32344L10.9 9.99844H8.225C8.10833 9.99844 8.029 10.0528 7.987 10.1614C7.945 10.2701 7.966 10.3658 8.05 10.4484L10.25 12.1984L9.425 14.8734C9.39167 14.9901 9.425 15.0861 9.525 15.1614C9.625 15.2368 9.725 15.2324 9.825 15.1484L12 13.4984ZM12 21.8984C11.8833 21.8984 11.775 21.8901 11.675 21.8734C11.575 21.8568 11.475 21.8318 11.375 21.7984C9.125 21.0484 7.33333 19.6608 6 17.6354C4.66667 15.6101 4 13.4311 4 11.0984V6.37344C4 5.95677 4.121 5.58177 4.363 5.24844C4.605 4.9151 4.91733 4.67344 5.3 4.52344L11.3 2.27344C11.5333 2.1901 11.7667 2.14844 12 2.14844C12.2333 2.14844 12.4667 2.1901 12.7 2.27344L18.7 4.52344C19.0833 4.67344 19.396 4.9151 19.638 5.24844C19.88 5.58177 20.0007 5.95677 20 6.37344V11.0984C20 13.4318 19.3333 15.6111 18 17.6364C16.6667 19.6618 14.875 21.0491 12.625 21.7984C12.525 21.8318 12.425 21.8568 12.325 21.8734C12.225 21.8901 12.1167 21.8984 12 21.8984Z"
        fill="#3D68FF"
      />
    </svg>
  );
};

export default FeedbackIcon;
